/**
 * Every word the case file's Design section and the preview review say about
 * a plan's UI preview. One module, so the card, the review and their tests
 * read the same sentences.
 */
export const DESIGN_COPY = {
  section: "Design",
  inPlan: "Design in this plan",
  approved: "Approved design",
  experiments: "Experiments",
  whatItShows: "What it shows",
  views: "Views",
  states: "States",
  choice: "Choice",
  readFrom: "Read from",
  reviewHere: "Review here",
  openInNewTab: "Open in new tab",
  drafting: "Reeve is drafting a preview of today's screen and the change.",
  redrafting: (revision: number) => `Reeve is drafting revision ${revision} from your feedback.`,
  revising: "Reeve is revising the plan.",
  failed: "Reeve could not draft a preview. The plan does not depend on it.",
  draftAgain: "Draft again",
  draftingAgain: "Drafting…",
  retryFailed: "Could not start another draft. The plan does not depend on it.",
  missing: (parts: string[]) =>
    `This preview is missing: ${parts.join(", ")}. The plan does not depend on it.`,
  kept: (revision: number) =>
    `Revision ${revision} is the one you made. Reeve kept it for this plan.`,
  approvedNotice:
    "This design is approved. Later revisions are experiments until a new plan review.",
  late: "Arrived after approval. Wright did not use it.",
  bylineFirst: "Reeve drafted this from today's code",
  bylineFeedback: "Reeve drafted this after your feedback",
  bylinePerson: "You revised this with @yagni",
  viewProposed: "Proposed",
  choiceOpen: (options: string[], question: number) =>
    `${options.join(" or ")} · question ${question}`,
  /** Follows the first file's name, which the card renders as code. */
  readFromMore: (more: number, sha: string | null) =>
    `${more > 0 ? ` + ${more} file${more === 1 ? "" : "s"}` : ""}${sha ? ` at ${sha.slice(0, 7)}` : ""}`,
  reviewing: (revision: number) => `Reviewing revision ${revision}`,
  reviewHint:
    "To change it, ask @yagni in the sidebar, or comment on the preview and send the plan back.",
  today: "Today",
  proposed: "Proposed",
  state: "State",
  amendmentDesign: (revision: number) => `With revision ${revision} of the design`,
  emptyCreate: "No prototype yet. Draft one when the shape of a screen is the open question.",
} as const;
